import { Box } from '@mui/material';
import { object } from 'prop-types';
import React, { Component } from 'react';
import ProgressiveImage from 'react-progressive-image';
import attachmentShape from 'shapes/attachment';
import connector from './connector';

class PictureTile extends Component {
  preview = () => {
    const { actions, picture } = this.props;
    actions.pictureModal.open(picture.httpLink);
  };

  render() {
    const { picture } = this.props;
    return (
      <Box
        onClick={this.preview}
        sx={{
          width: '100%',
          height: '100%',
          minHeight: 100,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer',
          '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            aspectRatio: '1/1',
          },
        }}
      >
        <ProgressiveImage
          onClick={this.openPicture}
          src={picture.meta.thumb || picture.httpLink}
          placeholder={picture.meta.placeholder}
        >
          {(src, loading) => (
            // eslint-disable-next-line jsx-a11y/alt-text
            <img
              src={src}
              style={
                loading
                  ? {
                      filter: 'blur(4px)',
                      transform: 'scale(1.05)',
                    }
                  : undefined
              }
            />
          )}
        </ProgressiveImage>
      </Box>
    );
  }
}

PictureTile.propTypes = {
  picture: attachmentShape.isRequired,
  actions: object.isRequired,
};

export default connector(PictureTile);
